import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { ModuleSettings, ChatViewRoutes, ChannelViewRoutes } from "./routes";
export default store => ({
  path: "messaging/settings",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "messaging-settings" */ "./components"),
        import(
          /* webpackChunkName: "messaging-settings" */ "MessagingV2/modules/MessagingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        injectReducer(store, {
          key: module.NAME,
          reducer: module.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    ModuleSettings(store),
    ..._.map(ChatViewRoutes, ChatViewRoute => ChatViewRoute(store)),
    ..._.map(ChannelViewRoutes, ChannelViewRoute => ChannelViewRoute(store)),
  ],
});
